import { Box } from '@mui/material';
import { notUndefiend, valueAsString } from 'helpers/conversions';
import React, { useRef } from 'react';
import { ICardProps, StatsData } from './Card';
import { Spinner, SpinnerContainer } from './Styles';
import { ReactComponent as ArrowUp } from '../../assets/icons/ArrowUp.svg';
import { animations } from 'theme';
import { styles } from './AvailabilityCardMobileDtg.styles';
const AvailabilityCardMobileDtg = (props: ICardProps) => {
  const {
    value,
    units,
    description,
    icons,
    stats,
    statsDescription,
    addedData,
    isPercentage,
  } = props;
  const isNegative = React.useMemo(() => {
    if (!notUndefiend([stats])) {
      return false;
    }
    if (stats! < 0) {
      return true;
    }
    if (description === 'Average Availability' && value !== undefined && value >= 0.999) {
      return false;
    }
    return false;
  }, [description, stats, value]);
  const rightColumnRef = useRef(null);
  const [rightColumnWidth, setRightColumnWidth] = React.useState(0);
  React.useEffect(() => {
    if (notUndefiend([stats])) {
      const { width } = rightColumnRef.current.getBoundingClientRect();
      setRightColumnWidth(width);
    }
  }, [stats]);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      width="100%"
      height="100%"
      boxSizing="border-box"
      sx={animations.appearanceEffect}>
      {notUndefiend([value]) ? (
        <>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            height="100%"
            boxSizing="border-box"
            sx={animations.appearanceEffect}>
            <Box display="flex" flexDirection="column" height="70px" boxSizing="border-box">
              <Box display="flex" alignItems="flex-start">
                <Box sx={styles.icon}>{isNegative ? icons.negative : icons.positive}</Box>
                <Box sx={styles.value} data-testid="availability-value">
                  {valueAsString(value, isPercentage)}
                </Box>
                <Box sx={styles.units} data-testid="availability-units">
                  {units}
                </Box>
              </Box>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={styles.leftColUpperRowDescriptionSubRow}>
                {description}
              </Box>
            </Box>
            <Box
              display="flex"
              alignItems="flex-end"
              height="30px"
              boxSizing="border-box"
              sx={styles.leftColBottomRow}
              data-testid="availability-description">
              {notUndefiend([stats]) && StatsData(stats)} {statsDescription}
            </Box>
          </Box>

          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            height="100%"
            boxSizing="border-box"
            sx={animations.appearanceEffect}
            ref={rightColumnRef}>
            <Box display="flex" flexDirection="column" boxSizing="border-box" sx={styles.rightColumnRow}>
              <Box display="flex" justifyContent="space-between" alignItems="baseline" width={rightColumnWidth}>
                <Box display="flex" justifyContent="flex-start" sx={styles.valueAndUnitWrapper} data-id="ValueAndUnitWrapper">
                  <Box sx={styles.rightColumnRowValueSubRowItemValue} data-testid="added-value">
                    {addedData.upper.formatter
                      ? addedData.upper.formatter(addedData.upper.value)
                      : valueAsString(addedData.upper.value!)}
                  </Box>
                  <Box sx={styles.rightColumnRowValueSubRowItemUnits} data-testid="added-units">
                    {addedData.upper.unit}
                  </Box>
                </Box>

                <Box>
                  {addedData.upper.trend !== 0 && addedData.upper.trend !== undefined && (
                    <ArrowUp
                      width={14}
                      height={18}
                      style={{ transform: addedData.upper.trend < 0 ? 'rotate(180deg)' : '' }}
                    />
                  )}
                </Box>
              </Box>
              <Box sx={styles.rightColumnRowDescriptionSubRow} data-testid="added-stats-description">
                {addedData.upper.description}
              </Box>
            </Box>

            <Box display="flex" flexDirection="column" boxSizing="border-box" sx={{ ...styles.rightColumnRow, borderBottom: 'none' }}>
              <Box display="flex" justifyContent="space-between" alignItems="baseline" width={rightColumnWidth}>
                <Box display="flex" justifyContent="flex-start" sx={styles.valueAndUnitWrapper} data-id="ValueAndUnitWrapper">
                  <Box sx={styles.rightColumnRowValueSubRowItemValue} data-testid="added-lower-value">
                    {addedData.lower.formatter
                      ? addedData.lower.formatter(addedData.lower.value)
                      : valueAsString(addedData.lower.value!)}
                  </Box>
                  <Box sx={styles.rightColumnRowValueSubRowItemUnits} data-testid="added-lower-units">
                    {addedData.lower.unit}
                  </Box>
                </Box>

                <Box>
                  {addedData.lower.trend !== 0 && addedData.lower.trend !== undefined && (
                    <ArrowUp
                      width={14}
                      height={18}
                      style={{ transform: addedData.lower.trend < 0 ? 'rotate(180deg)' : '' }}
                    />
                  )}
                </Box>
              </Box>
              <Box sx={styles.rightColumnRowDescriptionSubRow} data-testid="added-lower-stats-description">
                {addedData.lower.description}
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <SpinnerContainer>{Spinner()}</SpinnerContainer>
      )}
    </Box>
  );
};
export default AvailabilityCardMobileDtg;

